exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HomeAddress_addressCell_19QU {\n  vertical-align: middle;\n}\n\n.HomeAddress_buttonCell_1-_q {\n  width: 1px;\n}\n", ""]);

// exports
exports.locals = {
	"addressCell": "HomeAddress_addressCell_19QU",
	"buttonCell": "HomeAddress_buttonCell_1-_q"
};